import { useState } from "react";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import processApi from "../../api/processApi";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";
import AdminProductProcessModal from "./AdminProductProcessModal";

import { getLabel } from "../../tools/Dictionary";

const AdminProductProcess = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const OnCloseModal = props.OnCloseModal;
  const OnChangeProcess = props.OnChangeProcess;

  //State
  const [process, setProcess] = useState([]);
  const [currentProcess, setCurrentProcess] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({
    display: false,
    data: 0
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [column, setColumn] = useState([
    {
      label: getLabel("T_Process", "code"),
      property: "code",
      style: { width: "50%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "50%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Process", "description"),
      property: "description",
      style: { width: "50%", minWidth: "100px" },
      isMobile: true,
      mobileStyle: { width: "50%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    }
  ]);

  /*
  ,
    {
      label: getLabel("T_Process", "isTemplate"),
      property: "isTemplate",
      style: { width: "12%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
      filterOperator: "like",
      filterValue: ""
    }
  */
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 8
  });

  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async () =>
  {

    try
    {

      setLoading(true);

      let filter = "isActive is true and status.code ne '00'";

      if (Id){
        filter = `_id eq ${Id}`;
      }

      let processData = await processApi.getProcesses({ filter: filter, select: `_id,code,description,process`, sort: "code asc" });
      //let processData = await processApi.getPublishProcesses({ filter: filter, select: `_id,code,description,process`, sort: "code asc" });

      if (processData.Success)
      {

        let loadedProcess = applyListFilterAndSort(processData.Data, column, sort);

        setProcess(loadedProcess);
        checkDataUpdateForPagination(loadedProcess, pagination);


      } else
        throw new Error(processData.Error.label);
    

      if (Id){
        setModal({
          display: true,
          data: processData.Data.find(d => d._id == Id),
          readOnly: true
        });
      }

    
      setLoading(false);

    

    } catch (err)
    {


      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

    
  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentProcess(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(process, _sort);

    setProcess(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(process, _column);

    setProcess(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };

  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(process, tempPagination);

  };

  const onClickItem = (_item) => {

    
    setModal({
      display: true,
      data: _item
    });

  };

  const onConfirmSelection = () => {

    OnChangeProcess(modal.data);


    OnCloseModal();

  };

  const onCloseModal = () => {

    setModal({ display: false, data: {} });

    if (Id) OnCloseModal();

  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modal.display &&
          <AdminProductProcessModal
            IsDesktop={IsDesktop}
            Access={Access}
            Process={process.find(p => p._id == modal.data._id)}
            OnCloseModal={onCloseModal}
            OnConfirm={onConfirmSelection}
            ReadOnly={modal.readOnly}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("AdminProduct", "Choose a troubleshooting process")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_action_cont" style={{ width: "98%", maxWidth: "1200px", margin: "auto" }}>
            <div className="page_action_section" style={{ width: "30%" }}>
            </div>
            <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
              <Pagination
                IsDesktop={IsDesktop}
                data={pagination}
                onChangePage={onChangePage}
                count={process.filter(p => !p.bFiltered).length}
              />
            </div>
            <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
              <ListFilter
                IsDesktop={IsDesktop}
                column={column}
                Data={process}
                OnApplyFilter={onApplyFilter}
              />
            </div>
          </div>
          <div className="page_body_cont" style={{marginTop: "5px"}}>
            <ListComponent
              IsDesktop={IsDesktop}
              Column={column}
              Data={currentProcess}
              Sort={sort}
              ListStyle={{ width: "90%", maxWidth: "1200px" }}
              Loading={loading}
              Debug={false}
              OnClickSort={onClickSort}
              OnClickItem={onClickItem}
            />
          </div>

        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default AdminProductProcess